import type { TIconType } from '@cascade/ui-library';

export const getToggleIcon = (
  isRegular: boolean,
  isSidebarOpen: boolean,
): TIconType => {
  if (!isRegular) {
    return 'menu';
  }

  return isSidebarOpen ? 'aside-collapsed-filled' : 'aside-collapsed';
};
